import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button, Grid, Typography } from '@mui/material';
import { tracking } from '../../../../utils/tracking';
import { toggleDialog } from '../../../../store/control/duck';
import PieChart from 'lucide-react/dist/esm/icons/pie-chart';

const ButtonStyle = {
  padding: 3,
  lineHeight: 1,
  minWidth: 71,
  textTransform: 'unset'
};

const IconWrapperStyle = {
  margin: '4px 0'
};

const FinancialConceptButton = props => {
  const { intl, style, defaultItem, toggleDialog } = props;

  const openPurchasePowerDialog = () => {
    tracking('Click on Financial Concept - Fin Pyramid');
    toggleDialog('financialCharts', { defaultItem });
  };

  return (
    <Fragment>
      <Button color="primary" onClick={openPurchasePowerDialog} style={{ ...ButtonStyle, ...style }}>
        <Grid container sx={{ flexDirection: 'column', alignItems: 'center' }}>
          <Grid style={IconWrapperStyle}>
            <PieChart size={24} color="var(--new-theme)" />
          </Grid>
          <Grid>
            <Typography align="center" color="textSecondary">
              {intl.formatMessage({ id: 'fin-py-fin-charts' })}
            </Typography>
          </Grid>
        </Grid>
      </Button>
    </Fragment>
  );
};

const container = connect(state => ({}), {
  toggleDialog
})(FinancialConceptButton);

export default injectIntl(container);
